'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentKlarnaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "#F4B6C7",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.7361 37.4046H7.24138V21.75H10.7361V37.4046ZM19.4645 21.75H16.0446C16.0446 24.6308 14.7559 27.275 12.5089 29.0049L11.154 30.0478L16.4039 37.4052H20.7202L15.8897 30.6352C18.1795 28.2918 19.4645 25.1391 19.4645 21.75ZM25.0392 37.3994H21.7389V21.7521H25.0392V37.3994ZM35.0145 26.5765V27.2689C34.1237 26.6443 33.0485 26.2773 31.8889 26.2773C28.8198 26.2773 26.3319 28.8343 26.3319 31.9886C26.3319 35.1429 28.8198 37.7 31.8889 37.7C33.0485 37.7 34.1237 37.333 35.0145 36.7086V37.4003H38.1677V26.5765H35.0145ZM35.0041 31.9886C35.0041 33.5267 33.7249 34.7735 32.1469 34.7735C30.5691 34.7735 29.2898 33.5267 29.2898 31.9886C29.2898 30.4506 30.5691 29.204 32.1469 29.204C33.7249 29.204 35.0041 30.4506 35.0041 31.9886ZM68.2797 27.2689V26.5765H71.4328V37.4003H68.2797V36.7086C67.3889 37.333 66.3137 37.7 65.154 37.7C62.0849 37.7 59.5969 35.1429 59.5969 31.9886C59.5969 28.8343 62.0849 26.2773 65.154 26.2773C66.3137 26.2773 67.3889 26.6443 68.2797 27.2689ZM65.412 34.7735C66.99 34.7735 68.2691 33.5267 68.2691 31.9886C68.2691 30.4506 66.99 29.204 65.412 29.204C63.834 29.204 62.555 30.4506 62.555 31.9886C62.555 33.5267 63.834 34.7735 65.412 34.7735ZM72.8013 35.5949C72.8013 34.4717 73.6871 33.5612 74.7799 33.5612C75.8726 33.5612 76.7586 34.4717 76.7586 35.5949C76.7586 36.7179 75.8726 37.6285 74.7799 37.6285C73.6871 37.6285 72.8013 36.7179 72.8013 35.5949ZM53.9938 26.2853C52.7342 26.2853 51.5422 26.6872 50.7453 27.796V26.5771H47.6057V37.4003H50.7838V31.7123C50.7838 30.0664 51.8577 29.2604 53.1508 29.2604C54.5366 29.2604 55.3332 30.1112 55.3332 31.6899V37.4003H58.4826V30.5172C58.4826 27.9983 56.534 26.2853 53.9938 26.2853ZM43.0454 26.5766V27.9863C43.6775 27.1407 44.8553 26.5772 46.1357 26.5772V29.7268L46.1275 29.7266L46.1182 29.7261C46.1116 29.7258 46.105 29.7254 46.0982 29.7254C44.8507 29.7254 43.0526 30.6419 43.0526 32.3468V37.4003H39.8171V26.5766H43.0454Z",
          fill: "#17120F"
        }
      )
    ]
  }
);
const VpPaymentKlarnaAsset = forwardRef(PaymentKlarnaAsset);

export { VpPaymentKlarnaAsset as default };
